var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-sm-12"},[_c('p',{staticClass:"text-center paragraph",staticStyle:{"padding":"0px 30px"}},[_vm._v("\n        Before you proceed, please verify you're not a robot\n      ")]),_c('vue-recaptcha',{ref:"recaptcha",attrs:{"load-recaptcha-script":true,"sitekey":_vm.site_key},on:{"verify":_vm.onVerify}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }